import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import {
  forbiddenApiMessage,
  shouldShowForbiddenToast,
} from '../utils/forbidden-interceptor.util';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const messageService = inject(MessageService);
  const token = authService.getToken();
  const isAuthEndpoint =
    req.url.includes('/auth/login') || req.url.includes('/auth/logout');

  let request = req;
  if (token && !isAuthEndpoint) {
    request = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !req.url.includes('/auth/login')) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('user');
        void router.navigate(['/login']);
      }

      if (error.status === 403 && shouldShowForbiddenToast(req.url)) {
        messageService.add({
          severity: 'warn',
          summary: 'Permís denegat',
          detail: forbiddenApiMessage(error),
          life: 5000,
        });
      }

      return throwError(() => error);
    }),
  );
};
